import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[ls-image]'
})
export class ImageDirective implements OnInit {
  @Input()
  public src = '';
  @Input()
  public origin = '';

  constructor(private elementRef: ElementRef) {}

  public ngOnInit(): void {
    if (!this.origin) {
      this.origin = window.location.origin.replace('-web', '');
    }

    this.setImageSource(this.origin, this.src);
  }

  private setImageSource(prefix: string, src: string): void {
    this.elementRef.nativeElement.src = prefix + src;
  }
}
